/* Drives Horizon's own variant picker from the pack selector rows.
 *
 * Each pack row carries data-lum-variant="<variant id>". Picking a row finds
 * the matching input inside Horizon's <variant-picker> and clicks it, so the
 * THEME updates the price, availability, URL and the form's variant id. We do
 * not set any of that ourselves -- reimplementing a theme's variant state is
 * how you end up adding the wrong item to a cart.
 *
 * The native picker is visually hidden by CSS, not removed. It has to stay in
 * the DOM for this to work, and keeping it (rather than display:none) means
 * the theme's own measuring and focus handling still behave.
 *
 * NO-JS BEHAVIOUR: if this never runs, the rows do nothing and the hidden
 * picker is the only control. That is why lum-brand.css reveals the native
 * picker again under .no-js -- a shopper without JS still gets a working,
 * if plainer, way to choose a pack.
 */
(function () {
  if (window.lumBundleReady) return;
  window.lumBundleReady = true;

  function nativeInputFor(scope, variantId) {
    return scope.querySelector('variant-picker input[data-variant-id="' + variantId + '"]')
        || document.querySelector('variant-picker input[data-variant-id="' + variantId + '"]');
  }

  function bind(root) {
    if (root.dataset.lumBound === '1') return;
    root.dataset.lumBound = '1';

    var scope = root.closest('.product-details') || document;
    var radios = root.querySelectorAll('input[type="radio"][data-lum-variant]');
    if (!radios.length) return;

    // Read the merchant's pre-selected row BEFORE anything syncs from the
    // native picker. Horizon always starts on the first variant, so syncing
    // first would tick row 1 and silently discard a "Pre-selected row: 2".
    var preset = root.querySelector('input[type="radio"][data-lum-variant]:checked');

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        var native = nativeInputFor(scope, r.getAttribute('data-lum-variant'));
        if (!native || native.checked) return;
        native.click();
      });
    });

    // Keep the rows in step when the variant changes from anywhere else --
    // the native picker, a ?variant= URL, or the browser back button.
    function syncFromNative() {
      var checked = scope.querySelector('variant-picker input[data-variant-id]:checked')
                 || document.querySelector('variant-picker input[data-variant-id]:checked');
      if (!checked) return;
      var id = checked.getAttribute('data-variant-id');
      radios.forEach(function (r) {
        var mine = r.getAttribute('data-lum-variant') === id;
        if (mine && !r.checked) r.checked = true;
      });
    }

    var picker = scope.querySelector('variant-picker') || document.querySelector('variant-picker');
    if (picker) picker.addEventListener('change', syncFromNative);

    // On load: a ?variant= link is an explicit choice, so the theme's variant
    // wins and the rows follow it. Otherwise push the pre-selected row into
    // the theme, so the price, the form and the visible row agree before
    // anyone touches anything.
    if (/[?&]variant=/.test(location.search) || !preset) {
      syncFromNative();
    } else {
      var native = nativeInputFor(scope, preset.getAttribute('data-lum-variant'));
      if (native && !native.checked) native.click();
      else syncFromNative();
    }
  }

  function boot() {
    document.querySelectorAll('[data-lum-bundle]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
